"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioData = void 0;

var react_1 = __importDefault(require("react"));

var clsx_1 = __importDefault(require("clsx"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

require("./RadioData.scss");

var DataRow_1 = __importDefault(require("../DataRow/DataRow"));

exports.RadioData = function (_a) {
  var reference = _a.reference,
      address = _a.address,
      isTerminate = _a.isTerminate,
      className = _a.className,
      _b = _a.checked,
      checked = _b === void 0 ? false : _b,
      onChange = _a.onChange,
      id = _a.id,
      name = _a.name;
  return react_1.default.createElement("div", {
    className: clsx_1.default('py-3', 'row-data', className, {
      'row-data--checked': checked
    })
  }, react_1.default.createElement(react_theme_components_1.SzRadio, {
    id: id,
    name: name,
    label: react_1.default.createElement(DataRow_1.default, {
      reference: reference,
      address: address,
      isTerminate: isTerminate,
      className: 'pl-5 pr-3'
    }),
    checked: checked,
    onChange: onChange
  }));
};

exports.default = exports.RadioData;